import { render } from "./BetaWelcomePage.vue?vue&type=template&id=bc8222c4&scoped=true"
import script from "./BetaWelcomePage.vue?vue&type=script&lang=js"
export * from "./BetaWelcomePage.vue?vue&type=script&lang=js"

import "./BetaWelcomePage.vue?vue&type=style&index=0&id=bc8222c4&scoped=true&lang=css"
import "./BetaWelcomePage.vue?vue&type=style&index=1&id=bc8222c4&scoped=true&lang=css"
import "./BetaWelcomePage.vue?vue&type=style&index=2&id=bc8222c4&scoped=true&lang=css"
import "./BetaWelcomePage.vue?vue&type=style&index=3&id=bc8222c4&scoped=true&lang=css"
import "./BetaWelcomePage.vue?vue&type=style&index=4&id=bc8222c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8222c4"]])

export default __exports__